export const CopyrightFooter = () => {

  const height = "26px";
  return (
    <div style={{ textAlign: "center" }}>
      <p className="my-2 text-muted">
        &copy; Copyright HerdPlan 2024. All Rights Reserved.
      </p>
      <div className="d-flex gap-2 justify-content-around">
        <img src="img/sruc-logo.svg" alt="SRUC logo" height={height} />
        <img
          src="img/scotgovlogo.svg"
          alt="Scottish Government logo"
          height={height}
        />
      </div>
    </div>
  );
};
